import React from "react";

// Precise reproduction of the AstroLife emblem: royal-blue arrowhead "A",
// white four-point sparkle, ringed by twelve EU gold stars. Pure SVG, scalable.
function starPath(cx, cy, outer, inner, points = 5, rotDeg = -90) {
  const step = Math.PI / points;
  const rot = (rotDeg * Math.PI) / 180;
  let d = "";
  for (let i = 0; i < points * 2; i++) {
    const r = i % 2 === 0 ? outer : inner;
    const a = rot + i * step;
    const x = cx + r * Math.cos(a);
    const y = cy + r * Math.sin(a);
    d += (i === 0 ? "M" : "L") + x.toFixed(2) + " " + y.toFixed(2);
  }
  return d + "Z";
}

const EU_STARS = Array.from({ length: 12 }, (_, k) => {
  const a = (-90 + k * 30) * (Math.PI / 180);
  const cx = 50 + 41 * Math.cos(a);
  const cy = 50 + 41 * Math.sin(a);
  return starPath(cx, cy, 4.6, 1.9);
});

export function Emblem({ className = "", showStars = true, spinStars = false }) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      {showStars && (
        <g fill="#F5C518" className={spinStars ? "emblem-spin" : ""} style={{ transformOrigin: "50px 50px" }}>
          {EU_STARS.map((d, i) => (
            <path key={i} d={d} />
          ))}
        </g>
      )}
      {/* Blue arrowhead */}
      <g stroke="#2743E0" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" fill="none">
        <path d="M50 31 L31 74 Q30 77.5 33.5 77 Q37.5 76.4 39.5 72.5" />
        <path d="M50 31 L69 74 Q70 77.5 66.5 77 Q62.5 76.4 60.5 72.5" />
      </g>
      {/* White four-point sparkle */}
      <path d={starPath(50, 57, 12, 2.6, 4, -90)} fill="#FFFFFF" />
    </svg>
  );
}
